module.exports = __webpack_public_path__ + "img/web-camera1.4a3dd1ab.png";